import apiFetch from '../../apiFetch'

export default function (values, token) {
  return apiFetch({endPoint: `Intervencion/imprimirRegistroIntervenciones`, method: 'POST', body: values, token: token})
}
